<template>
  <v-app>
    <v-main>
    <v-card
      flat
      height="480px"
      width="100%"
      max-width="430px"
      style="
        position: absolute;
        top: 10%;
        left: calc(50% - 215px);
        z-index: 1000;
        margin: auto;
      "
    >
      <v-card-title
        class="justify-center mt-4"
        style="font-size: 1.4rem; font-weight: 600"
      >
       <div style="width: 100%; text-align: center; padding-top: 10px">
        <img src="../assets/DNA-Logo.png" width="170px" />
      </div>
      </v-card-title>

      <v-stepper v-model="loginStep" class="elevation-0">
        <v-stepper-items>
          <v-stepper-content step="1" class="elevation-0">
            <div class="mb-12 mt-12">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="User Name"
                    placeholder="Registered email"
                    outlined
                    v-model="emailId"
                  ></v-text-field>
                </v-col>

                 <v-col cols="12">
                  <v-text-field
                    label="Password"
                    placeholder=""
                    outlined
                    v-model="password"
                    type="password"
                  ></v-text-field>
                </v-col>
 <v-col cols="12">
 <div style="text-align: center">
              <v-btn color="primary" large @click="createlogin"> Login </v-btn>
            </div>
 </v-col>

              </v-row>
            </div>
           
          </v-stepper-content>

          <v-stepper-content step="2">
            <div class="mb-4">
              <div class="pt-3 pb-3 mb-3 justify-center">
                <v-chip
                  @click="loginStep = 1"
                  style="width: 100%; text-align: center !important"
                  ><v-icon left>mdi-keyboard-backspace</v-icon>
                  {{ emailId }}
                </v-chip>
              </div>
              <v-row>
               
              </v-row>
            </div>
           
          </v-stepper-content>

          <v-stepper-content step="3">
            <div class="mb-4">
              <div class="pt-3 pb-3 mb-3 justify-center">
                <v-chip
                  @click="loginStep = 1"
                  style="width: 100%; text-align: center !important"
                  ><v-icon left>mdi-keyboard-backspace</v-icon>
                  {{ emailId }}
                </v-chip>
              </div>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Enter OTP"
                    placeholder=""
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <div style="text-align: center">
              <v-btn color="primary" large @click="loginStep = 3"> Validate </v-btn>
            </div>
          </v-stepper-content>
          <v-stepper-content step="4">
            <v-card
              class="mb-12"
              color="grey lighten-1"
              height="200px"
            ></v-card>

            <v-btn color="primary" @click="e1 = 1"> Continue </v-btn>

            <v-btn text>Cancel</v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
    <v-carousel
      :continuous="true"
      :cycle="true"
      :interval="5000"
      height="100vh"
    >
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="item.src"
      ></v-carousel-item>
    </v-carousel>
    </v-main>
  </v-app>
</template>

<script>
//import axios from 'axios';
export default {
  layout: "login",
  data() {
    return {
      loginStep: 1,
      emailId: "",
      password:"",
      appData:{
        email:"",
        password:"",
      },
      items: [
        {
          src: "Images/banner1.jpeg",
        },
        {
          src: "Images/banner1.jpeg",
        },
       
      ],
    };
  },
  methods:{
    createlogin: function(){
      this.appData.email=this.emailId;
      this.appData.password=this.password;
     // alert(this.appData.email + "/" + this.appData.password);
     if(this.appData.email=="superadmin" && this.appData.password=="s123")
     {
this.$router.push("/admin");
     }
     else{
       alert("Invalid User and password");
     }

//       this.appData.email=this.emailId;
//       this.appData.password=this.password;
//        axios
//             .post(this.$apiPath + "EventApp/EventAdminLogin", this.appData, {
//               headers: { Appkey: this.$aKey },
//             })
//             .then((res) => {
//               if (res.data.status == "Success") {
//                 console.log(res.data.result);
//                 if(res.data.result.length>0){
// this.$store.commit("setEventInfo",res.data.result[0]);
// this.$router.push("/dashboard");
//                 }
               
//               }
//             })
//             .catch()
//             .finally();


    }
  },
};
</script>

<style>
.text-center {
  text-align: center;
}
</style>